import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import DrawerDMC from './drawerDMC';
import CustomerType from './CustomerType';
import { DatePicker, Table, Select, } from 'antd';
import { checkAccess } from '../../../../common/utils/index';
import style from './index.scss';
import moment from 'moment';
const { Option } = Select;

const resourceCode = 'APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE';

const { RangePicker } = DatePicker;

const dateFormat = 'DD/MM/YYYY';

export const CustomerTypeMatchingConfig = ({
  apiActions,
  saveRunInstanceConfigToStore,
  data,
  handleChange,
  getNSMatchingConfigListData,
  getNSMatchingConfig,
  dataSource,
  individualMatchingConfigData,
  checkCompletion,
  authentication = {},
  customerTypeList,
  createUpdateRunInstanceConfig,
}) => {
  const defaultDates = data?.dateRange;

  const [dates, setDates] = useState(defaultDates);
  const [referrer, setReferrer] = useState('');
  const [visible, setvisible] = useState(false);
  const [isCardView, setCardView] = useState(true);
  const [isListView, setListView] = useState(false);
  const [matchingConfigsMap, setMatchingConfigsMap] = useState({
    DEFAULT: null,
    ...data?.matchingConfigs
  });
  const [customerTypeSelected, setCustomerTypeSelected] = useState('');

  useEffect(() => {
    apiActions?.getCustomerType();
  }, []);

  useEffect(() => {
    let updatedMatchingConfigMap = { ...matchingConfigsMap };

    if (individualMatchingConfigData) {
      const { data, } = individualMatchingConfigData;
      if (data) {
        Object.keys(matchingConfigsMap).forEach(itemKey => {
          if (matchingConfigsMap[itemKey]['matchingConfigId'] === data['id']) {
            updatedMatchingConfigMap[itemKey] = {
              ...matchingConfigsMap[itemKey],
              matchingConfigCompleteData: data,
            };
          }
        });
      }
    }

    setMatchingConfigsMap(updatedMatchingConfigMap);
  }, [individualMatchingConfigData]);

  const onCalendarChange = (val) => {
    if (
      val[0] !== null &&
      val[1] !== null &&
      matchingConfigsMap?.DEFAULT !== null
    ) {
      checkCompletion(false);
    } else {
      checkCompletion(true);
    }

    setDates(val);

    handleChange('dateRange', val);

    saveRunInstanceConfigToStore(
      'customerTypeMatchingConfig',
      { dateRange: val, matchingConfigs: matchingConfigsMap },
      true
    );
  };

  const openDrawer = (ref, customerTypeId) => {
    if (matchingConfigsMap['DEFAULT'] || ref === 'DEFAULT') {
      setReferrer(ref);
      setCustomerTypeSelected(customerTypeId);
      setvisible(true);
    }
  };

  const onClose = () => setvisible(false);

  const onSelect = (e) => {
    if (
      (matchingConfigsMap.DEFAULT !== null || referrer === 'DEFAULT') &&
      dates[0] !== null &&
      dates[1] !== null
    )
      checkCompletion(false);
    else checkCompletion(true);

    setMatchingConfigsMap({
      ...matchingConfigsMap,
      [referrer]: {
        matchingConfigId: e[0].id,
        matchingConfigName: e[0].name,
        customerType: customerTypeSelected,
        isDefault: referrer == 'DEFAULT' ? true : false
      }
    });

    saveRunInstanceConfigToStore(
      'customerTypeMatchingConfig',
      {
        dateRange: dates,
        matchingConfigs: {
          ...matchingConfigsMap,
          [referrer]: {
            matchingConfigId: e[0].id,
            matchingConfigName: e[0].name,
            customerType: customerTypeSelected,
            isDefault: referrer == 'DEFAULT' ? true : false
          }
        }
      },
      true
    );

    if (e && e[0] && e[0].id) {
      getNSMatchingConfig({ id: e[0].id });
    }
  };

  const closeTag = (ref) => {
    setMatchingConfigsMap({
      ...matchingConfigsMap,
      [ref]: null
    });
    if (ref == 'DEFAULT') checkCompletion(true);

    saveRunInstanceConfigToStore(
      'customerTypeMatchingConfig',
      {
        dateRange: dates,
        matchingConfigs: {
          ...matchingConfigsMap,
          [ref]: null
        }
      },
      true
    );
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  const toggleView = viewType => {
    switch (viewType) {
      case 'cardView':
        setCardView(true);
        setListView(false);
        return;
      case 'listView':
        setCardView(false);
        setListView(true);
        return;
      default:
        setCardView(true);
        setListView(false);
        return;
    }
  }

  const returnStringFromArrayOfObjects = (paramArray, objectKey) => {
    if (Array.isArray(paramArray) && paramArray.length > 0 && objectKey) {
      let updatedString = '';

      paramArray.forEach(item => {
        if (updatedString !== '') {
          updatedString += `, ${item[objectKey]}`;
        } else {
          updatedString += `${item[objectKey]}`;
        }
      });
      return updatedString
    }

    return '--';
  }

  const listViewColumns = [
    {
      title: 'Segment Name',
      dataIndex: 'displayName',
      key: 'displayName',
      render: (text, record) => (
        <span>{record?.customer.displayName}</span>
      )
    },
    {
      title: 'Select Matching Configuration',
      dataIndex: 'matchingConfig',
      key: 'matchingConfig',
      render: (text, record) => (
        <Select className={style.matchingConfigDropdown} disabled={matchingConfigsMap['DEFAULT'] ? false : true} value={matchingConfigsMap?.[record.customer.code] ? record.customer.code : null} onClick={() => openDrawer(record.customer.code, record.customer.id)}>
          {matchingConfigsMap?.[record.customer.code] ? <Option value={record.customer.code}>{matchingConfigsMap?.[record.customer.code]['matchingConfigName']}</Option> : null}
        </Select>
      )
    },
    {
      title: 'Watchlist Details',
      dataIndex: 'watchlist',
      key: 'watchlist',
      render: (text, record) => (
        <p>{matchingConfigsMap?.[record.customer.code]
          && matchingConfigsMap?.[record.customer.code]['matchingConfigCompleteData'] ?
          returnStringFromArrayOfObjects(matchingConfigsMap?.[record.customer.code]['matchingConfigCompleteData']['watchlist'], 'name') :
          '--'
        }</p>
      )
    },
    {
      title: 'Whitelist Details',
      dataIndex: 'watchlist',
      key: 'watchlist',
      render: (text, record) => (
        <p>{matchingConfigsMap?.[record.customer.code]
          && matchingConfigsMap?.[record.customer.code]['matchingConfigCompleteData'] ?
          returnStringFromArrayOfObjects(matchingConfigsMap?.[record.customer.code]['matchingConfigCompleteData']['whitelist'], 'name') :
          '--'
        }</p>
      )
    },
  ];

  return (
    <React.Fragment>
      <div className={style.ctMatchConfig}>
        <div style={{ marginBottom: '24px' }}>
          <label
            id="rangePickerLabel"
            className={classNames(style.label, style.required)}>
            Date Range
          </label>
          <br />
          <RangePicker
            value={dates}
            onCalendarChange={onCalendarChange}
            onChange={onCalendarChange}
            inputReadOnly={true}
            format={dateFormat}
            size="small"
            style={{
              cursor: 'pointer'
            }}
            disabled={!checkAccess(authentication, resourceCode, 'Write')}
            disabledDate={disabledDate}
          />
        </div>

        <div>
          <label
            id="addMatchingConfig"
            className={classNames(style.label, style.required)}>
            Default Matching Configuration
          </label>
          <div id="add-defualtMC-btn-wrapper">
            <CustomerType
              id={`add-defualtMC-btn`}
              data={{ id: 1, code: 'DEFAULT' }}
              addMatchingConfig={openDrawer}
              closeTag={closeTag}
              referrer={'DEFAULT'}
              value={matchingConfigsMap?.['DEFAULT']}
              authentication={authentication}
            />
          </div>
        </div>

        <div id="add-customerTypeMC-btn-wrapper">
          <label id="addcustomerTypeMatchingConfig" className={style.label}>
            Segments and Matching Configurations
            <div className={style.toggleViewButtons}>
              <div id="toggleCardViewButton" className={isCardView ? style.toggleButtonActive : style.toggleButton} onClick={() => toggleView('cardView')}><i className='fa fa-th-large'></i></div>
              <div id="toggleListViewButton" className={isListView ? style.toggleButtonActive : style.toggleButton} onClick={() => toggleView('listView')}><i className='fa fa-list'></i></div>
            </div>
          </label>
          <div className={style.customerType_wrapper}>
            {isCardView && customerTypeList?.data?.map((item, index) => (
              <React.Fragment key={index}>
                <CustomerType
                  id={`add-${item.customer.code}MC-btn`}
                  data={item.customer}
                  addMatchingConfig={(ref) => openDrawer(item.customer.code, item.customer.id)}
                  closeTag={closeTag}
                  referrer={item?.customer.code}
                  value={matchingConfigsMap?.[item.customer.code]}
                  authentication={authentication}
                  disabled={matchingConfigsMap?.DEFAULT == null}
                />
              </React.Fragment>
            ))}

            {isListView && <React.Fragment>
              <Table className={style.table} dataSource={customerTypeList?.data} columns={listViewColumns} />
            </React.Fragment>}

          </div>
        </div>

        {visible && (
          <DrawerDMC
            authentication={authentication}
            visible={visible}
            close={onClose}
            select={onSelect}
            isLoading={dataSource.isLoading}
            mcData={dataSource.data}
            getNSMatchingConfigListData={getNSMatchingConfigListData}
            createUpdateRunInstanceConfig={createUpdateRunInstanceConfig}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CustomerTypeMatchingConfig;
